import { Button, DropdownMenu } from '@radix-ui/themes'
import React, { useState, useEffect } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';

export default function Navbar() {
  const [data, setData] = useState(localStorage.getItem("userData"));
  const pdata = JSON.parse(data);
  useEffect(() => {
    const interval = setInterval(() => {
      const storedData = localStorage.getItem("userData");
      if (storedData !== null && storedData !== data) {
        setData(storedData);
      }
    }, 1000); // Check every second

    return () => clearInterval(interval);
  }, [data]);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("userData");
    toast.success("User Log Out Successfull")
    setData(null); // Clear the name state
    navigate("/");
  }

  return (
    <header className="text-gray-600 body-font">
      <div className="mx-auto flex flex-wrap p-3 flex-col md:flex-row items-center">
        <NavLink to={"/"} className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
          <img src='https://media.istockphoto.com/id/967255466/vector/handshake-icon-vector-illustration.jpg?s=612x612&w=0&k=20&c=8yqvBlIpOR1M1fRMMjpD4ETI79y6aRCGivKW-egDbpE=' alt='...' width={50}/>
          <span className="ml-3 text-xl">Hostel Share</span>
        </NavLink>
        <nav className="md:ml-auto md:mr-auto flex flex-wrap items-center text-base justify-center">
        {data !== null ?
          <NavLink className="mr-5 hover:text-gray-900" to={'/home'}>Home</NavLink>
          :
          <NavLink className="mr-5 hover:text-gray-900" to={'/'}>Home</NavLink>
          }
          <NavLink className="mr-5 hover:text-gray-900" to={'/about'}>About</NavLink>
          <NavLink className="mr-5 hover:text-gray-900" to={'/contact'}>Contact</NavLink>


          {data !== null ?
            <DropdownMenu.Root color="white">
              <DropdownMenu.Trigger>
                <Button variant="soft">
                  Services
                  <DropdownMenu.TriggerIcon />
                </Button>
              </DropdownMenu.Trigger>
              <DropdownMenu.Content>
                <Link to={"/additem"}>
                <DropdownMenu.Item >Add Item</DropdownMenu.Item>
                </Link>
                <Link to={"/fetchitems"}>
                <DropdownMenu.Item >Fetch All Your Item's</DropdownMenu.Item>
                </Link>

              </DropdownMenu.Content>
            </DropdownMenu.Root>
            : ""}
        </nav>

        {data === null || data.length === 0 ? <>
          <NavLink to={"/login"}>
            <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Login</button>
          </NavLink>
          <NavLink to={"/signup"}>
            <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Sign Up</button>
          </NavLink> </> : <>
          <div style={{marginRight:"5px"}}>{pdata.name}</div>
          <button type="button" onClick={handleLogout} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Logout</button>
        </>}


      </div>
    </header>
  )
}
